module.exports = __webpack_public_path__ + "static/media/julie_final.710a5d51.jpg";